import styled from 'styled-components'

export const Wrapper = styled.div`
    width: 100%;
   /*  min-height: 100vh; */
  /*   display: flex;
    align-items: center;
    justify-content: center; */
    z-index: 997;
`